import { vuexPersistKey } from '~/plugins/vuex-persist';

export class Module {
  constructor($nuxt) {
    this.$auth = $nuxt.$auth;
    this.$analytics = $nuxt.$analytics;
  }

  logout() {
    this.$auth.logout();

    window.localStorage?.removeItem(vuexPersistKey());
  }
}

export const LogoutSetup = (nuxt) => {
  const module = new Module(nuxt);

  nuxt.$auth.logoutUser = () => module.logout();
};
